import { render, staticRenderFns } from "./previewCard.vue?vue&type=template&id=91654a52&scoped=true"
import script from "./previewCard.vue?vue&type=script&lang=js"
export * from "./previewCard.vue?vue&type=script&lang=js"
import style0 from "./previewCard.vue?vue&type=style&index=0&id=91654a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91654a52",
  null
  
)

export default component.exports